import { useEffect, useState } from "react";

/**
 * Shared "is the promo banner currently hidden by scroll" state so the header
 * can slide up to the top in sync with the banner retracting.
 */
let hidden = false;
const listeners = new Set<(v: boolean) => void>();
let started = false;
let timeout: ReturnType<typeof setTimeout> | null = null;

function set(next: boolean) {
  if (hidden === next) return;
  hidden = next;
  listeners.forEach((l) => l(next));
}

function start() {
  if (started || typeof window === "undefined") return;
  started = true;

  const handleScroll = () => {
    if (window.scrollY > 50) {
      set(true);
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => set(false), 3000);
    } else {
      if (timeout) clearTimeout(timeout);
      set(false);
    }
  };

  window.addEventListener("scroll", handleScroll, { passive: true });
  handleScroll();
}

export function useBannerHidden(): boolean {
  const [value, setValue] = useState(hidden);

  useEffect(() => {
    start();
    setValue(hidden);
    listeners.add(setValue);
    return () => {
      listeners.delete(setValue);
    };
  }, []);

  return value;
}
